import { useContext } from 'react';
import { DialogContext } from './DialogProvider';

function useDialog() {
  const { dialog, addDialog, closeDialog } = useContext(DialogContext);
  return { dialog, addDialog, closeDialog };
};

export default useDialog;